import api from './api' 

export const transfereeApi = {
  get(id) {
    return api.get(`/transferees/${id}`)
      .then(response => response.data)
  },
  getDropdownOptions(id) {
    const url = id ? `/transferees/${id}/dropdown_options` : `/transferees/dropdown_options`
    return api.get(url).then(response => response.data)
  },
  getAssociatedRecords(id) {
    return api.get(`/transferees/${id}/associated_records`)
      .then(response => response.data)
  },    
  create(params={}) {
    return api.post('/transferees', params)
      .then(response => response.data)
  },
  update(id, params={}) {
    return api.put(`/transferees/${id}`, params)
      .then(response => response.data)
  },
  delete(id) {
    return api.delete(`/transferees/${id}`)
      .then(response => response.data)
  },    
  updateTodo(id, todoId, params={}) {
    return api.put(`/transferees/${id}/todos/${todoId}`, params)
      .then(response => response.data)
  },
  createTodo(id, params={}) {
    return api.post(`/transferees/${id}/todos`, params)
      .then(response => response.data)
  },
  deleteTodo(id, todoId, params={}) {
    return api.delete(`/transferees/${id}/todos/${todoId}`)
      .then(response => response.data)
  },  
};